import {
  PriceSummary,
  PriceSummaryRow
} from '@ps-design-system/components/PriceSummary';
import { Text } from '@ps-design-system/components/Text';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedDate, FormattedMessage, FormattedNumber } from 'react-intl';

export const SplitPaymentPriceSummary = ({
  splitPaymentCalculations,
  splitPaymentChargeDate,
  currency
}) => {
  const { parts, fee } = splitPaymentCalculations || {};

  return (
    <div
      style={{
        padding: '16px',
        backgroundColor: '#F8F9FA',
        borderRadius: '4px',
        border: '1px solid #E9EBEF'
      }}
    >
      <PriceSummary textSize="large" testId="split-payment-price-summary">
        <PriceSummaryRow
          testId="split-payment-line-item"
          name={(
            <FormattedMessage
              id="price_summary.due_now_with_fee"
              defaultMessage="{dueNow} (includes {feeAmount} fee)"
              values={{
                dueNow: (
                  <Text typeface="body-2-m">
                    <FormattedMessage
                      id="price_summary.due_now"
                      defaultMessage="Due now"
                    />
                  </Text>
                ),
                feeAmount: (
                  <FormattedNumber
                    value={fee}
                    style="currency"
                    currency={currency}
                  />
                )
              }}
            />
          )}
          value={(
            <Text typeface="body-2-m">
              <FormattedNumber
                value={parts?.[0]}
                style="currency"
                currency={currency}
              />
            </Text>
          )}
        />

        <PriceSummaryRow
          name={(
            <FormattedMessage
              id="price_summary.due_on"
              defaultMessage="Due on {splitPaymentChargeDate}"
              values={{
                splitPaymentChargeDate: (
                  <FormattedDate
                    value={splitPaymentChargeDate}
                    month="short"
                    day="numeric"
                  />
                )
              }}
            />
          )}
          value={(
            <FormattedNumber
              value={parts?.[1]}
              style="currency"
              currency={currency}
            />
          )}
        />
      </PriceSummary>
    </div>
  );
};

SplitPaymentPriceSummary.displayName = 'SplitPaymentPriceSummary';
SplitPaymentPriceSummary.propTypes = {
  splitPaymentCalculations: PropTypes.object,
  splitPaymentChargeDate: PropTypes.string,
  currency: PropTypes.string
};
